const ProviderDirectory = () => {
  return (
    <div>
      <h1>Provider Directory API</h1>
    </div>
  );
}

export default ProviderDirectory;